import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export type VoiceTier = 'free' | 'premium';

export interface VoiceUsageSnapshot {
  tier: VoiceTier;
  usedMs: number;
  capMs: number;
  remainingMs: number;
  percentUsed: number;
  resetsAt: string;
  isOverCap: boolean;
}

export const VOICE_USAGE_QUERY_KEY = ['voice', 'usage'] as const;

export function useVoiceUsage(enabled = true) {
  return useQuery({
    queryKey: VOICE_USAGE_QUERY_KEY,
    queryFn: async () => {
      const res = await api.get<VoiceUsageSnapshot>('/api/voice/usage');
      if (res.error || !res.data) {
        throw new Error(res.error?.message ?? 'Voice usage unavailable');
      }
      return res.data;
    },
    enabled,
    staleTime: 30_000,
    retry: false,
  });
}
